import styled from 'styled-components';

import { media } from '@mlb/react-patterns/style/helpers/media.ts';
import COLORS from '@mlb/react-patterns/style/universal.color';

import ModalContainer from 'bdvp-common/src/containers/Modal';

export const Modal = styled(ModalContainer)`
    overflow: unset;

    @supports (padding-top: constant(safe-area-inset-top)) {
        --safe-area-inset-top: constant(safe-area-inset-top, 0);
        height: calc(99% - var(--safe-area-inset-top));
        padding-bottom: constant(safe-area-inset-bottom, 0);
    }

    @supports (padding-top: env(safe-area-inset-top)) {
        --safe-area-inset-top: env(safe-area-inset-top, 0);
        height: calc(99% - var(--safe-area-inset-top));
        padding-bottom: env(safe-area-inset-bottom, 0);
    }

    ${media.mdmin`
        height: 100%;

        @supports (padding-top: constant(safe-area-inset-top)) {
            padding-top: constant(safe-area-inset-top, 0);
        }

        @supports (padding-top: env(safe-area-inset-top)) {
            padding-top: env(safe-area-inset-top, 0);
        }
    `}
`;

export const ModalFooter = styled.div`
    display: ${(props) => props.hide ? 'none' : 'flex'};
    justify-content: center;
    width: 100%;
    padding-top: 12px;
    padding-bottom: 24px;
    box-shadow: 0 0 7px 0 rgba(136, 136, 136, 0.49);
    background-color: ${COLORS.mlbGrey7};
`;
